import React, { useMemo } from 'react'
import DOMPurify from 'dompurify'
import { ExpandableSection } from '../../components/ExpandableSection/ExpandableSection'
import useFacetRevisitLink from '../../../hooks/useFacetRevisitLink'

interface AdvisorDisclosureProps {
  disclosure: string
}

// Nested accordion rendered inside AdvisorAdditionalInfo. It is styled as an
// element of the `.advisor-additional-info` block (see the .scss) so it shares
// the parent's toggle styling via the descendant selector and only overrides
// what differs (no border).
export const AdvisorDisclosure = ({ disclosure }: AdvisorDisclosureProps) => {
  // Prefill any Facet revisit links in the disclosure with the user's stored
  // answers (email/phone/name), bringing the redesigned screen to parity with
  // the legacy match screen. Done on the raw markup, before sanitizing.
  const prefilledDisclosure = useFacetRevisitLink(disclosure) || ''

  // disclosure is advisor-supplied HTML markup — sanitize as the final step
  // before injecting to strip any XSS vectors. It is already HTML (not
  // markdown), so sanitize directly rather than running it through the markdown
  // pipeline. Sanitizing last ensures the link prefill above can't bypass it.
  const sanitizedMarkup = useMemo(
    () => DOMPurify.sanitize(prefilledDisclosure, { USE_PROFILES: { html: true } }),
    [prefilledDisclosure]
  )

  return (
    <ExpandableSection label='Disclosure' className='advisor-additional-info__disclosure-section'>
      <div className='advisor-additional-info__disclosure' dangerouslySetInnerHTML={{ __html: sanitizedMarkup }} />
    </ExpandableSection>
  )
}
